import React, { ReactNode } from 'react'
import { Avatar, Box } from '@node-space/ui-components'

export interface CustomerDetailsHeaderProps {
  name: string
  description: string
  StatusHighlight?: ReactNode
}

export const CustomerDetailsHeader = ({
  name,
  description,
  StatusHighlight,
}: CustomerDetailsHeaderProps) => {
  return (
    <Box flex gap={16}>
      <Avatar size="large" type="entity" name={name ?? ''} />
      <Box>
        <h2 className="text-h2 text-foreground-prominent">{name}</h2>
        {!!description && (
          <p className="text-body-regular text-foreground-subdued">{description}</p>
        )}
        {StatusHighlight && <Box paddingT={8}>{StatusHighlight}</Box>}
      </Box>
    </Box>
  )
}
